import { render, staticRenderFns } from "./StatisticsPage.vue?vue&type=template&id=54608816&scoped=true&"
import script from "./StatisticsPage.vue?vue&type=script&lang=js&"
export * from "./StatisticsPage.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsPage.vue?vue&type=style&index=0&id=54608816&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54608816",
  null
  
)

export default component.exports